module.exports = __webpack_public_path__ + "img/sophie-profilepix.941c9d7d.jpg";